import { render, staticRenderFns } from "./DispatchAboutYou.vue?vue&type=template&id=4b98545a&scoped=true"
import script from "./DispatchAboutYou.vue?vue&type=script&lang=js"
export * from "./DispatchAboutYou.vue?vue&type=script&lang=js"
import style0 from "./DispatchAboutYou.vue?vue&type=style&index=0&id=4b98545a&prod&module=true&scoped=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4b98545a",
  null
  
)

export default component.exports